import type { ReactNode } from 'react'

// Legacy MarketingButton wrapped Blueprint's AnchorButton/Button; the split is kept — with an
// href it renders a real anchor (navigation must survive without JS), otherwise a button.
// The inner <span> is what the hover style recolors — see landing.scss.
export function MarketingButton({
  children,
  href = '',
  type = 'button',
  disabled = false,
}: {
  children: ReactNode
  href?: string
  type?: 'button' | 'submit'
  disabled?: boolean
}) {
  if (href) {
    return (
      <a href={href} className="marketing-button">
        <span>{children}</span>
      </a>
    )
  }

  return (
    <button type={type} className="marketing-button" disabled={disabled}>
      <span>{children}</span>
    </button>
  )
}
